import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../ui";

const getPageItems = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  if (currentPage <= 4) return [1, 2, 3, 4, 5, "end-gap", totalPages];
  if (currentPage >= totalPages - 3) {
    return [
      1,
      "start-gap",
      totalPages - 4,
      totalPages - 3,
      totalPages - 2,
      totalPages - 1,
      totalPages,
    ];
  }

  return [
    1,
    "start-gap",
    currentPage - 1,
    currentPage,
    currentPage + 1,
    "end-gap",
    totalPages,
  ];
};

export const LogPagination = ({
  page,
  pages,
  total,
  limit,
  visibleCount,
  hasSearch,
  onPageChange,
}) => {
  if (!total) return null;

  const currentPage = Math.min(Math.max(page || 1, 1), Math.max(pages, 1));
  const totalPages = Math.max(pages || 1, 1);
  const start = (currentPage - 1) * limit + 1;
  const end = Math.min(currentPage * limit, total);
  const pageItems = getPageItems(currentPage, totalPages);

  return (
    <nav className="audit-pagination" aria-label="Audit log pagination">
      <p className="audit-pagination-summary">
        Showing <strong>{start}–{end}</strong> of <strong>{total}</strong> logs
        {hasSearch && ` · ${visibleCount} match this page`}
      </p>

      <div className="audit-pagination-controls">
        <Button
          variant="neutral"
          appearance="outline"
          size="sm"
          icon={<ChevronLeft size={15} />}
          onClick={() => onPageChange(currentPage - 1)}
          disabled={currentPage <= 1}
          aria-label="Go to previous audit log page"
        >
          Previous
        </Button>

        <div className="audit-pagination-pages" role="group" aria-label="Choose a page">
          {pageItems.map((item) =>
            typeof item === "string" ? (
              <span className="audit-pagination-ellipsis" key={item} aria-hidden="true">
                …
              </span>
            ) : (
              <Button
                key={item}
                variant={item === currentPage ? "primary" : "neutral"}
                appearance={item === currentPage ? "filled" : "ghost"}
                size="sm"
                className="audit-pagination-page"
                onClick={() => onPageChange(item)}
                aria-label={`Go to audit log page ${item}`}
                aria-current={item === currentPage ? "page" : undefined}
              >
                {item}
              </Button>
            ),
          )}
        </div>

        <span className="audit-pagination-mobile-page">
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </span>

        <Button
          variant="neutral"
          appearance="outline"
          size="sm"
          icon={<ChevronRight size={15} />}
          iconPosition="end"
          onClick={() => onPageChange(currentPage + 1)}
          disabled={currentPage >= totalPages}
          aria-label="Go to next audit log page"
        >
          Next
        </Button>
      </div>

      <p className="audit-pagination-page-context">
        Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
      </p>
    </nav>
  );
};
